import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import type { Product } from '../../types'
import * as db from '../../services/db'

const CATEGORIES = ['Fruits', 'Vegetables', 'Dairy', 'Snacks', 'Drinks', 'Pantry']

export function ProductListView() {
  const [products, setProducts] = useState<Product[]>([])
  const [filter, setFilter] = useState<string>('')

  useEffect(() => {
    db.getAllProducts().then(setProducts)
  }, [])

  const filtered = filter
    ? products.filter((p) => p.category === filter)
    : products

  const remove = async (id: string, isPrebuilt: boolean) => {
    if (isPrebuilt) return
    if (window.confirm('Delete this product?')) {
      await db.deleteProduct(id)
      setProducts(await db.getAllProducts())
    }
  }

  return (
    <>
      <h2 className="page-title">Product List</h2>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
        <button
          type="button"
          className={filter === '' ? 'btn-primary' : 'btn-secondary'}
          onClick={() => setFilter('')}
        >
          All
        </button>
        {CATEGORIES.map((c) => (
          <button
            key={c}
            type="button"
            className={filter === c ? 'btn-primary' : 'btn-secondary'}
            onClick={() => setFilter(c)}
          >
            {c}
          </button>
        ))}
      </div>
      <Link to="/parent/new" className="btn-large btn-primary" style={{ textDecoration: 'none', marginBottom: 24 }}>
        + Add Product
      </Link>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, width: '100%', maxWidth: 560 }}>
        {filtered.map((p) => (
          <li
            key={p.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 0',
              borderBottom: '1px solid #eee',
            }}
          >
            <span style={{ fontSize: '1.5rem', marginRight: 12 }}>{p.imagePath}</span>
            <span style={{ flex: 1 }}>{p.name}</span>
            <span style={{ marginRight: 8 }}>${p.price.toFixed(2)}</span>
            <span style={{ color: 'var(--text-muted)', marginRight: 8 }}>{p.category}</span>
            <Link to={`/parent/edit/${p.id}`} className="btn-secondary" style={{ padding: '8px 12px', textDecoration: 'none', marginRight: 8 }}>
              Edit
            </Link>
            {!p.isPrebuilt && (
              <button type="button" className="btn-secondary" style={{ padding: '8px 12px' }} onClick={() => remove(p.id, p.isPrebuilt)}>
                Delete
              </button>
            )}
          </li>
        ))}
      </ul>
    </>
  )
}
